export default "__VITE_ASSET__B67_NJ_P__"